<footer class="d-flex justify-content-center fixed-bottom">
    <div
        class="col-12 d-flex align-items-center justify-content-center text-16 text-white">
        © 2024 Forza Delivery Express S.A.
    </div>
</footer>
